import { render, staticRenderFns } from "./CardCarouselMod.vue?vue&type=template&id=4970298e"
import script from "./CardCarouselMod.vue?vue&type=script&lang=js"
export * from "./CardCarouselMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports